export default "__VITE_ASSET__F0rh5twt__"